import { useMediaQuery } from '@react-hook/media-query';

import createMinMediaQuery from 'utils/createMinMediaQuery';

const useCustomMediaQuery = (screenSize) => useMediaQuery(createMinMediaQuery(screenSize));

export default useCustomMediaQuery;
